import React from 'react';
import { CardActions, RefreshButton } from 'react-admin';

export const UserEditActions = () => {
  return (
    <CardActions>
      <RefreshButton />
    </CardActions>
  );
}



// WEBPACK FOOTER //
// ./src/actions/UserEdit.js